import { useQuery } from "@tanstack/react-query";
import { salonProfileQuery } from "@/features/salon";
import { type Theme, useResolvedTheme } from "@/lib/theme.store";

/**
 * The theme on screen: the customer's choice, else the salon's (FR-SA-189). Until the profile
 * arrives the page is light, the default, so a phone in dark mode does not flash dark first. Only a
 * salon that chose "Phone setting" follows the phone.
 */
export function usePageTheme(): Theme {
  const { data } = useQuery(salonProfileQuery());
  const salon = data?.pageTheme;
  return useResolvedTheme(salon === "Dark" ? "dark" : salon === "Phone setting" ? null : "light");
}
